import { render, staticRenderFns } from "./imgTextList.vue?vue&type=template&id=9d982cfe&scoped=true"
import script from "./imgTextList.vue?vue&type=script&lang=js"
export * from "./imgTextList.vue?vue&type=script&lang=js"
import style0 from "./imgTextList.vue?vue&type=style&index=0&id=9d982cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d982cfe",
  null
  
)

export default component.exports